var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "modal fade",
        {
          show: _vm.getIsOpenSecondStepDeleteAccountModal,
          "d-block": _vm.getIsOpenSecondStepDeleteAccountModal,
          notAllowClick: _vm.isLoadingDeleteAccount,
        },
      ],
      staticStyle: { display: "block" },
      attrs: {
        id: "go-modal-accountDelete-step2",
        "aria-hidden": "true",
        tabindex: "-1",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog go-modal-prompt" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("div", { staticClass: "modal-title" }, [
              _vm._v(
                _vm._s(_vm.$t("myPage.profile.secondStepDeletePopup.title"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon close",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleCloseModal.apply(null, arguments)
                  },
                },
              },
              [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("P", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "myPage.profile.secondStepDeletePopup.description.firstText"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "myPage.profile.secondStepDeletePopup.description.secondText"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "go-form-group" }, [
                _c("label", { staticClass: "go-form-label" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "myPage.profile.secondStepDeletePopup.inputDeleteKeyTitle"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.inputDeleteLogin,
                      expression: "inputDeleteLogin",
                    },
                  ],
                  staticClass: "go-form-control",
                  attrs: {
                    type: "email",
                    placeholder: _vm.$t(
                      "myPage.profile.secondStepDeletePopup.placeHolderDeleteKeyInput"
                    ),
                    minlength: "1",
                    maxlength: "191",
                  },
                  domProps: { value: _vm.inputDeleteLogin },
                  on: {
                    input: [
                      function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.inputDeleteLogin = $event.target.value
                      },
                      _vm.checkCanDeleteUser,
                    ],
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "custom-control custom-checkbox" }, [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.isConfirmDelete },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.setIsConfirmDelete.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "myPage.profile.secondStepDeletePopup.checkedConfirmText"
                          )
                        )
                      ),
                    ]
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-default",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.handleCloseModal.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "myPage.profile.secondStepDeletePopup.cancelButtonTitle"
                      )
                    ) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn go-btn-primary",
                attrs: {
                  type: "button",
                  disabled: !(
                    _vm.canDeleteAccount &&
                    _vm.inputDeleteLogin &&
                    _vm.isConfirmDelete
                  ),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.deleteUser.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "myPage.profile.secondStepDeletePopup.deleteButtonTitle"
                      )
                    ) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }